query GetLegalEntityByName($name: String!) {
  legalEntityByName(name: $name) {
    id
    name
    currencies
    salesforceName
    sageId
  }
}
